import fetchProposalContent from './fetchProposalContent';

export default (values = {}) =>
    (dispatch) => {
        const { contentId, initTemplate } = values;
        dispatch(fetchProposalContent(contentId, initTemplate));
    };
